exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-content {\n  display: flex;\n  flex: 1;\n  padding: 10px;\n  flex-direction: column;\n}\n\n.me {\n  position: fixed;\n  bottom: 6rem;\n  right: 4rem;\n  padding: 2rem;\n  border-radius: 50%;\n  background-color: #2395f1;\n  color: white;\n}", ""]);

// exports
